import { render, staticRenderFns } from "./404.vue?vue&type=template&id=20c78fdc&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=20c78fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c78fdc",
  null
  
)

export default component.exports